import React, { useState } from 'react';
import { Colors as C } from '../../constants/Colors.js';
import { MP_SURF } from '../constants/surfaces.js';
import VinylCover from './VinylCover.js';
import PartnerRoleBadges from './PartnerRoleBadges.js';
import PartnerVerifiedBadge from './PartnerVerifiedBadge.js';
import { isDreamvinylVerifiedPartner } from '../utils/partnerVerified.js';
import Icon from './Icon.js';

function ReportListingButton({ onReport, item }) {
  if (typeof onReport !== 'function') return null;
  return (
    <button
      type="button"
      title="Reportar anuncio"
      aria-label="Reportar anuncio"
      onClick={e => {
        e.stopPropagation();
        onReport(item);
      }}
      style={{
        position: 'absolute',
        top: 6,
        right: 6,
        width: 30,
        height: 30,
        display: 'grid',
        placeItems: 'center',
        background: 'rgba(14,14,20,0.92)',
        color: 'rgba(255,255,255,0.75)',
        border: MP_SURF.cardBorder,
        borderRadius: 8,
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
        zIndex: 2,
        padding: 0,
        lineHeight: 0,
      }}
    >
      <Icon name="report" size={15} color="currentColor" stroke={2} />
    </button>
  );
}

export function GridItem({ item, onClick, onLike, liked, onReport }) {
  const cc = { M: C.green, 'VG+': '#7dd4b8', VG: C.gold, 'G+': C.warn, G: C.warn, P: C.danger };
  const showReport = typeof onReport === 'function';
  return (
    <div
      className="disco-card-mp card-hover"
      style={{
        background: MP_SURF.card,
        borderRadius: 12,
        overflow: 'hidden',
        border: MP_SURF.cardBorder,
        cursor: 'pointer',
        transition: 'all .22s ease',
        position: 'relative',
      }}
    >
      <div onClick={onClick} style={{ aspectRatio: '5 / 4', position: 'relative', overflow: 'hidden', background: '#0a0a12' }}>
        <VinylCover item={item} listingThumb />
      </div>
      <div
        style={{
          padding: '9px 10px 10px',
          paddingRight: showReport ? 44 : 10,
          position: 'relative',
        }}
      >
        {showReport ? <ReportListingButton onReport={onReport} item={item} /> : null}
        {item.type ? (
          <div
            onClick={onClick}
            style={{
              fontSize: 10,
              color: MP_SURF.textMuted,
              marginBottom: 3,
              lineHeight: 1.2,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.type}
          </div>
        ) : null}
        <div onClick={onClick} style={{ fontWeight: 600, fontSize: '0.8rem', marginBottom: 1, lineHeight: 1.2, color: MP_SURF.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.title}</div>
        <div onClick={onClick} style={{ fontSize: '0.72rem', color: MP_SURF.textMuted, marginBottom: 3, lineHeight: 1.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.artist}</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 4 }}>
          <span onClick={onClick} style={{ fontFamily: 'Georgia,serif', color: C.gold, fontWeight: 700, fontSize: '0.9rem', flexShrink: 0 }}>{item.isAuction ? `${item.currentBid}€` : `${item.price}€`}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, flexShrink: 0 }}>
            <span style={{ fontSize: '0.62rem', fontWeight: 700, color: cc[item.condition] || MP_SURF.textDim }}>{item.condition}</span>
            <button type="button" title="Marcar si te interesa comprarlo — aparece en Favoritos" className="like-btn" onClick={e => { e.stopPropagation(); onLike(); }} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.82rem', transition: 'transform .18s', padding: 0, lineHeight: 1 }}>{liked ? '❤️' : '🤍'}</button>
          </div>
        </div>
        <div
          onClick={onClick}
          style={{
            fontSize: '0.61rem',
            color: MP_SURF.textSoft,
            marginTop: 3,
            lineHeight: 1.25,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          📍 {[item.ciudad, item.localidad].filter(Boolean).join(', ') || item.location} ·{' '}
          <span style={{ color: C.gold, display: 'inline-flex', alignItems: 'center', gap: 3 }}>
            @{item.seller}
            {isDreamvinylVerifiedPartner(item) ? <PartnerVerifiedBadge size={14} /> : null}
          </span>
        </div>
        {Array.isArray(item.sellerPartnerRoleKeys) && item.sellerPartnerRoleKeys.length > 0 ? (
          <PartnerRoleBadges
            roleKeys={item.sellerPartnerRoleKeys}
            compact
            theme="dark"
            style={{ marginTop: 4 }}
          />
        ) : null}
      </div>
    </div>
  );
}

export function ListaItem({ item, onClick, onLike, liked, onReport }) {
  const [h, setH] = useState(false);
  return (
    <div
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      style={{
        background: MP_SURF.card,
        borderRadius: 10,
        border: h ? '0.5px solid rgba(200,168,75,0.45)' : MP_SURF.cardBorder,
        transition: 'all .18s',
        display: 'grid',
        gridTemplateColumns: '75px 1fr auto',
        marginBottom: 6,
        overflow: 'hidden',
      }}
    >
      <div onClick={onClick} style={{ width: 75, height: 75, cursor: 'pointer', position: 'relative', overflow: 'hidden', background: '#0a0a12' }}>
        <VinylCover item={item} listingThumb />
      </div>
      <div
        onClick={onClick}
        style={{
          padding: '9px 13px',
          paddingRight: typeof onReport === 'function' ? 42 : 13,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          cursor: 'pointer',
          position: 'relative',
          minWidth: 0,
        }}
      >
        {typeof onReport === 'function' ? <ReportListingButton onReport={onReport} item={item} /> : null}
        <div style={{ fontWeight: 600, fontSize: '0.9rem', color: MP_SURF.text }}>{item.title}</div>
        <div style={{ fontSize: '0.76rem', color: MP_SURF.textMuted }}>{item.artist} · {item.year} · {item.genre}</div>
        <div style={{ display: 'flex', gap: 5, marginTop: 3 }}>
          <span style={{ background: item.type === 'SUBASTA' ? 'rgba(83,74,183,0.2)' : 'rgba(200,168,75,0.14)', color: item.type === 'SUBASTA' ? C.purpleL : C.gold, padding: '2px 6px', borderRadius: 3, fontSize: '0.65rem', fontWeight: 700 }}>{item.type}</span>
          <span style={{ color: MP_SURF.textDim, fontSize: '0.7rem' }}>📍 {[item.ciudad, item.localidad].filter(Boolean).join(', ') || item.location}</span>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6, marginTop: 4 }}>
          <span style={{ color: C.gold, fontSize: '0.68rem', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 3 }}>
            @{item.seller}
            {isDreamvinylVerifiedPartner(item) ? <PartnerVerifiedBadge size={14} /> : null}
          </span>
          <PartnerRoleBadges roleKeys={item.sellerPartnerRoleKeys} compact theme="dark" />
        </div>
      </div>
      <div style={{ padding: '9px 14px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', gap: 4 }}>
        <span style={{ fontFamily: 'Georgia,serif', color: C.gold, fontWeight: 700, fontSize: '1.02rem' }}>{item.isAuction ? `${item.currentBid}€` : `${item.price}€`}</span>
        <span style={{ fontSize: '0.68rem', color: MP_SURF.textMuted }}>{item.condition}</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button type="button" title="Marcar si te interesa comprarlo — aparece en Favoritos" className="like-btn" onClick={e => { e.stopPropagation(); onLike(); }} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.9rem', transition: 'transform .18s', padding: 0 }}>{liked ? '❤️' : '🤍'}</button>
        </div>
      </div>
    </div>
  );
}
